import { FilterOperatorUi } from "@common/api/filterTypes.ts";

export const appliesToAllGroupCompaniesFilterId = "appliesToAll";

// A document with no restriction is visible to every group company, so it matches any selection. That is also what
// lets the synthetic "applies to all" entry work without a branch of its own: no restricted document carries that
// id, so selecting it on its own leaves exactly the unrestricted documents.
export function matchesGroupCompanyFilter(selectedIds: Array<string>, operator: FilterOperatorUi | undefined, groupEntityAccessIds: Array<string>) {
    if (selectedIds.length === 0) return true;

    const isVisibleToSelected = groupEntityAccessIds.length === 0 || groupEntityAccessIds.some((id) => selectedIds.includes(id));
    return operator === FilterOperatorUi.Negative ? !isVisibleToSelected : isVisibleToSelected;
}
